<template lang="html">
  <v-container grid-list-lg :fluid="true" class="pa-3 bgs-container">
    <v-layout v-bind="binding">

      <v-flex sm12 md12 lg3 xl2>
        <v-card class="filters-container">
          <v-system-bar color="accent" dark window @click.native="isFiltersVisible = !isFiltersVisible" style="cursor: pointer;">
            <v-icon center>filter_list</v-icon>
            <v-toolbar-title class="ml-0">Фильтры</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small icon class="mx-0">
              <v-icon class="mx-0">{{ isFiltersVisible ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
            </v-btn>
          </v-system-bar>
          <v-slide-y-transition>
            <v-card-text v-show="isFiltersVisible" class="pa-0">
              <template v-if="filterLoadingError">
                <v-alert :value="true" type="error" outline>
                  Произошла ошибка при загрузке фильтров
                </v-alert>
                <v-btn small @click="getFiltersData()" color="secondary">
                  <v-icon left>cached</v-icon>
                  Повторить
                </v-btn>
              </template>
              <FilterContainer v-else 
                :loading="loadingFilters" 
                :filters="filters" 
                v-on:filtersChange="onFiltersChange" 
              />
            </v-card-text>
          </v-slide-y-transition>
        </v-card>
      </v-flex>

      <v-flex sm12 md12 lg9 xl10>
        <v-card height="100%">
          <v-system-bar color="accent" dark window>
            <v-icon center>list</v-icon>
            <v-toolbar-title class="ml-0">Список процессов</v-toolbar-title>
          </v-system-bar>
          <v-card-text>
            <template v-if="dataLoadingError">
              <v-alert :value="true" type="error" outline>
                Произошла ошибка при загрузке данных
              </v-alert>
              <v-btn @click="getListData()" color="secondary" small class="ml-0">
                <v-icon left>cached</v-icon>
                Повторить
              </v-btn>
            </template>

            <v-data-table v-else
                          :headers="headers"
                          :items="items"
                          :pagination.sync="pagination"
                          :total-items="totalItems"
                          :loading="loading"
                          class="monitor-data-table"
                          id="process-list-table"
                          item-key="id"
                          rows-per-page-text="Элементов на страницу"
                          :rows-per-page-items="rowsPerPageDefault"
                          no-data-text="Нет доступных данных"
                          no-results-text="Не найдено подходящих значений"
            >
              <template slot="items" slot-scope="props">
                <tr :id="'testTarget-' + props.item.id"
                    @click="props.expanded = !props.expanded; selectItem( props.item )"
                    :class="{ 'selected-row': currentItem && props.item.id === currentItem.id, 'new-item' : props.item.isNew}"
                >
                  <td>
                    <template v-if="props.item.labels">
                      <strong v-if="props.item.labels.self" v-text="props.item.labels.self"></strong>
                      <small v-if="props.item.labels.parent" v-text="props.item.labels.parent"></small>
                    </template>
                    <template v-else>&nbsp;</template>
                  </td>
                  <td class="text-xs-left">{{ props.item.start_port_name }}</td>
                  <td class="text-xs-center">
                    <v-chip outline :color="getStatusColor( props.item.status )" disabled small>
                      {{ getStatusName( props.item.status ) }}
                    </v-chip>
                  </td>
                  <td class="text-xs-left">{{ getHumanDateFromSec( props.item.started_at ) }}</td>
                  <td class="text-xs-left">
                    <div>{{ getProgressValue( props.item ) }}</div>
                    <div :class="getProgressFloorClass( props.item )" style="margin-top: 4px; height: 2px;">
                      <div :class="getProgressValueClass( props.item )" style="height: 100%;" :style="getProgressValueStyle( props.item )">
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

              <template slot="expand" slot-scope="props">
                <v-container grid-list-lg fluid class="bgs-container py-3 px-1">
                  <v-layout row wrap>

                    <!-- Описание -->
                    <v-flex xs12 v-if="props.item.description">
                      <!-- <h3 class="title mb-1">Описание</h3> -->
                      <p><span>Описание бизес-процесса:</span><br/>{{ props.item.description }}</p>
                    </v-flex>

                    <!-- Запуск / Начало исполнения -->
                    <v-flex xs12 sm12 md4>
                      <v-card class="process-step-info">
                        <v-system-bar color="accent" dark window>
                          <v-icon center>mdi-numeric-1-box-outline</v-icon>
                          <v-toolbar-title class="subheading ml-0">Начало / Запуск</v-toolbar-title>
                        </v-system-bar>
                        <v-list two-line dense class="">
                          <!-- Customer Info -->
                          <d-being v-if="props.item.customer_id" :id="props.item.customer_id" type="post">
                            <div slot="default" slot-scope="{ being, type, data }">
                              <v-list-tile v-if="being.loaded !== false">
                                <!-- Данные загружены -->
                                <v-list-tile-avatar>
                                  <being-avatar :being="being" />
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ being.fullname }}&nbsp;/&nbsp;<small>{{ being.name }}</small></v-list-tile-title>
                                  <v-list-tile-sub-title>Запустивший процесс</v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>
                              <v-list-tile v-else avatar>
                                <!-- Загрузка -->
                                <v-list-tile-avatar>
                                  <v-icon>face</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <loading flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                </v-list-tile-content>
                              </v-list-tile>
                            </div>
                          </d-being>
                          <v-list-tile v-else>
                            <v-list-tile-avatar>
                              <v-icon>mdi-account-off</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title>отсутствует</v-list-tile-title>
                              <v-list-tile-sub-title>Запустивший процесс</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <template
                            v-for="(itemProp, index) in getMonitorItemProperties( props.item, ['started', 'time_limit', 'instruction'] )"
                            v-if="itemProp.title || itemProp.subTitle"
                          >
                            <v-list-tile v-if="itemProp.command" :avatar="itemProp.avatar" v-on:click="itemProp.command" :disabled="itemProp.disabled ? true : false">
                              <v-list-tile-avatar>
                                <img v-if="itemProp.image" :src="itemProp.image"/>
                                <v-icon v-else-if="itemProp.avatarIcon">{{ itemProp.avatarIcon }}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title v-if="itemProp.title">{{ itemProp.title }}</v-list-tile-title>
                                <v-list-tile-sub-title v-if="itemProp.subTitle">{{ itemProp.subTitle }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <loading v-if="itemProp.loading" flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                <v-btn v-else-if="itemProp.action" icon disabled color="secondary">
                                  <v-icon v-html="itemProp.actionIcon"></v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile v-else :avatar="itemProp.avatar" :disabled="itemProp.disabled ? true : false">
                              <v-list-tile-avatar>
                                <img v-if="itemProp.image" :src="itemProp.image"/>
                                <v-icon v-else-if="itemProp.avatarIcon">{{ itemProp.avatarIcon }}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title v-if="itemProp.title">{{ itemProp.title }}</v-list-tile-title>
                                <v-list-tile-sub-title v-if="itemProp.subTitle">{{ itemProp.subTitle }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <loading v-if="itemProp.loading" flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                <v-btn v-else-if="itemProp.action" icon disabled color="secondary">
                                  <v-icon v-html="itemProp.actionIcon"></v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                          </template>
                        </v-list>
                        <v-slide-y-transition v-if="props.item.instruction">
                          <v-card-text v-show="isInstructionVisible">
                            <v-card>
                              <v-card-text v-html="props.item.instruction" />
                            </v-card>
                          </v-card-text>
                        </v-slide-y-transition>
                      </v-card>
                    </v-flex>

                    <!-- Исполнение процесса / задания -->
                    <v-flex xs12 sm12 md4>
                      <v-card class="process-step-info">
                        <v-system-bar color="accent" dark window
                                      :class="{ 'pink': ['hold', 'pool', 'pending'].includes(props.item.status), 'amber': props.item.status === 'running', 'green': props.item.status === 'finished' }"
                        >
                          <v-icon center>mdi-numeric-2-box-outline</v-icon>
                          <v-toolbar-title class="subheading ml-0">Исполнение</v-toolbar-title>
                        </v-system-bar>

                        <v-list two-line dense>
                          <!-- Contractor Info -->
                          <d-being v-if="props.item.contractor_id" :id="props.item.contractor_id" type="post">
                            <div slot="default" slot-scope="{ being, type, data }">
                              <v-list-tile v-if="being.loaded !== false">
                                <!-- Данные загружены -->
                                <v-list-tile-avatar>
                                  <being-avatar :being="being" />
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ being.fullname }}</v-list-tile-title>
                                  <v-list-tile-sub-title>Исполнитель</v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>
                              <v-list-tile v-else avatar>
                                <!-- Загрузка -->
                                <v-list-tile-avatar>
                                  <v-icon>face</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <loading flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                </v-list-tile-content>
                              </v-list-tile>
                            </div>
                          </d-being>
                          <v-list-tile v-else>
                            <v-list-tile-avatar>
                              <v-icon>mdi-account-off</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title>Не назначен</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <template
                            v-for="(itemProp, index) in getMonitorItemProperties( props.item, ['executed', 'deadline', 'hold', 'canceled', 'input'] )"
                            v-if="itemProp.title || itemProp.subTitle"
                          >

                            <!-- Command present -->
                            <v-list-tile v-if="itemProp.command"
                                         :avatar="itemProp.avatar"
                                         v-on:click="itemProp.command"
                                         :disabled="itemProp.disabled ? true : false"
                            >
                              <v-list-tile-avatar>
                                <img v-if="itemProp.image" :src="itemProp.image"/>
                                <v-icon v-else-if="itemProp.avatarIcon">{{ itemProp.avatarIcon }}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title v-if="itemProp.title">{{ itemProp.title }}</v-list-tile-title>
                                <v-list-tile-sub-title v-if="itemProp.subTitle">{{ itemProp.subTitle }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <loading v-if="itemProp.loading" flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                <v-btn v-else-if="itemProp.action" icon disabled color="secondary">
                                  <v-icon v-html="itemProp.actionIcon"></v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>

                            <!-- Command absent -->
                            <v-list-tile v-else
                                         :avatar="itemProp.avatar"
                                         :disabled="itemProp.disabled ? true : false"
                            >
                              <v-list-tile-avatar>
                                <img v-if="itemProp.image" :src="itemProp.image"/>
                                <v-icon v-else-if="itemProp.avatarIcon">{{ itemProp.avatarIcon }}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title v-if="itemProp.title">{{ itemProp.title }}</v-list-tile-title>
                                <v-list-tile-sub-title v-if="itemProp.subTitle">{{ itemProp.subTitle }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <loading v-if="itemProp.loading" flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                <v-btn v-else-if="itemProp.action" icon disabled color="secondary">
                                  <v-icon v-html="itemProp.actionIcon"></v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>

                          </template>

                        </v-list>

                        <!-- Input data -->
                        <v-slide-y-transition v-if="props.item.data && props.item.data.input">
                          <v-card-text v-show="isInputDataVisible">
                            <div class="mb-2" v-for="(dataItem, indexData) in props.item.data.input" :key="indexData">
                                <DataItemRow :data-item="dataItem"></DataItemRow>
                            </div>
                          </v-card-text>
                        </v-slide-y-transition>

                        <!-- Footer with actions -->
                        <v-card-actions v-if="['pool', 'pending'].includes(props.item.status)">
                          <v-spacer></v-spacer>
                          <v-btn color="secondary" small @click.native="startExecution()">Приступить к исполнению</v-btn>
                        </v-card-actions>

                      </v-card>
                    </v-flex>

                    <!-- Завершение исполнения -->
                    <v-flex xs12 sm12 md4>
                      <v-card class="process-step-info">
                        <v-system-bar color="accent" window dark :class="{ 'pink': props.item.status !== 'finished', 'green': props.item.status === 'finished' }">
                          <v-icon center>mdi-numeric-3-box-outline</v-icon>
                          <v-toolbar-title class="subheading ml-0">Завершение</v-toolbar-title>
                        </v-system-bar>

                        <v-list two-line dense class="">
                          <template
                            v-for="(itemProp, index) in getMonitorItemProperties( props.item, ['status', 'finished', 'output'] )"
                            v-if="itemProp.title || itemProp.subTitle"
                          >
                            <v-list-tile v-if="itemProp.command" :avatar="itemProp.avatar" v-on:click="itemProp.command" :disabled="itemProp.disabled ? true : false">
                              <v-list-tile-avatar>
                                <img v-if="itemProp.image" :src="itemProp.image"/>
                                <v-icon v-else-if="itemProp.avatarIcon">{{ itemProp.avatarIcon }}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title v-if="itemProp.title">{{ itemProp.title }}</v-list-tile-title>
                                <v-list-tile-sub-title v-if="itemProp.subTitle">{{ itemProp.subTitle }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <loading v-if="itemProp.loading" flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                <v-btn v-else-if="itemProp.action" icon disabled color="secondary">
                                  <v-icon v-html="itemProp.actionIcon"></v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile v-else :avatar="itemProp.avatar" :disabled="itemProp.disabled ? true : false">
                              <v-list-tile-avatar>
                                <img v-if="itemProp.image" :src="itemProp.image"/>
                                <v-icon v-else-if="itemProp.avatarIcon">{{ itemProp.avatarIcon }}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title v-if="itemProp.title">{{ itemProp.title }}</v-list-tile-title>
                                <v-list-tile-sub-title v-if="itemProp.subTitle">{{ itemProp.subTitle }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <loading v-if="itemProp.loading" flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                <v-btn v-else-if="itemProp.action" icon disabled color="secondary">
                                  <v-icon v-html="itemProp.actionIcon"></v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                          </template>

                          <!-- Завершение работы -->
                          <div v-if="loadingItemDataId == props.item.id" class="text-xs-center mt-4">
                            <loading flat :message="false" progress="circular" color="primary" size="32" width="3" />
                          </div>
                          <template v-if="['running'].includes(props.item.status) && props.item.ports && (props.item.ports.length > 0)">
                            <template v-if="props.item.extended_finish">
                              <!-- Расширенное завершение -->
                              <v-subheader>Отправить данные в выходной порт</v-subheader>
                              <v-list-tile avatar v-for="port in props.item.ports" :key="port.id" @click="showFlexForm( port.id )">
                                <v-list-tile-avatar>
                                  <!-- <v-icon>gavel</v-icon> -->
                                  <v-icon>mdi-export</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ port.name }}</v-list-tile-title>
                                  <v-list-tile-sub-title>{{ port.description }}</v-list-tile-sub-title>
                                  <!-- <v-list-tile-sub-title>{{ port.id }}</v-list-tile-sub-title> -->
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>

                            <!--<template v-else>-->
                              <!--&lt;!&ndash; Обычное завершение &ndash;&gt;-->
                              <!--<v-subheader v-if="props.item.ports.length > 1">Варианты завершения работы</v-subheader>-->
                              <!--<v-subheader v-else>Завершение работы</v-subheader>-->
                              <!--<v-list-tile avatar v-for="port in props.item.ports" :key="port.id" @click="showFlexForm( port.id )">-->
                                <!--<v-list-tile-avatar>-->
                                  <!--&lt;!&ndash; <v-icon>gavel</v-icon> &ndash;&gt;-->
                                  <!--<v-icon>mdi-export</v-icon>-->
                                <!--</v-list-tile-avatar>-->
                                <!--<v-list-tile-content>-->
                                  <!--<v-list-tile-title>{{ port.name }}</v-list-tile-title>-->
                                  <!--<v-list-tile-sub-title>{{ port.description }}</v-list-tile-sub-title>-->
                                  <!--&lt;!&ndash; <v-list-tile-sub-title>{{ port.id }}</v-list-tile-sub-title> &ndash;&gt;-->
                                <!--</v-list-tile-content>-->
                              <!--</v-list-tile>-->
                            <!--</template>-->

                            <template v-else>
                              <!-- Обычное завершение -->
                              <v-subheader>Завершение работы</v-subheader>
                              <v-list-tile avatar @click="showFlexForm()">
                                <v-list-tile-avatar>
                                  <!-- <v-icon>gavel</v-icon> -->
                                  <v-icon>mdi-export</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>Завершение работы</v-list-tile-title>
                                  <v-list-tile-sub-title>Заполните исходящие данные для завершения процесса</v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>

                          </template>
                        </v-list>

                        <v-card-actions v-if="['running'].includes(props.item.status) && loadingItemDataId != props.item.id && props.item.extended_finish">
                          <v-btn flat color="secondary" @click.native="finishExecution()">Завершить выполнение</v-btn>
                        </v-card-actions>

                        <!-- Output data -->
                        <v-slide-y-transition>
                          <v-card-text v-show="isOutputDataVisible" v-if="props.item.data && props.item.data.output">
                            <v-card flat>
                              <v-toolbar color="accent" card dense>
                                <v-toolbar-title class="subheading">Выходной порт</v-toolbar-title>
                              </v-toolbar>
                              <v-card-text>
                                <div class="mb-2" v-for="( dataItem, indexData ) in props.item.data.output" :key="indexData">
                                  <DataItemRow :data-item="dataItem"></DataItemRow>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-card-text>
                        </v-slide-y-transition>

                      </v-card>
                    </v-flex>

                  </v-layout>
                </v-container>
              </template>
            </v-data-table>
          </v-card-text>

        </v-card>
      </v-flex>

      <!-- Loading indicator modal -->
      <LoadingModal :visible="isLoadingModalVisible"></LoadingModal>

      <process-control-panel
        mode="finish"
        :quickFinish="true"
        :stepper="true"
        :process="currentItem"
        ref="processDataForm"
        @finish=""
        @confirm="sendFlexFormData"
        @cancel=""
      ></process-control-panel>

    </v-layout>
  </v-container>
</template>

<script>
import { debounce } from 'lodash'
import { mapGetters } from 'vuex'
import _ from 'lodash'

import apiRoutes from '../api/routes'
import httpClient from '@/api/http-client'
const http = httpClient.http

import commons from '../../mixins/commons'
import time_limit from '../../mixins/time_limit'
import monitor from '../../mixins/monitor'
import monitor_item_properties from '../../mixins/monitor_item_properties'
import filtered_list_routing from '../../mixins/filtered_list_routing'

import LoadingModal from '../components/utils/LoadingModal'
import FlexForm from '../components/FlexForm'
// import Form from '../../components/form/Form'
import ProcessControlPanel from '../../components/process/ProcessControlPanel'

import FilterContainer from '../../components/FilterContainer'
import BeingAvatar from '../../components/BeingAvatar'

import DBeing from '@/components/Being'
import DataItemRow from '../../components/DataItemRow'

const consoleDebug = Boolean(process.env.NODE_ENV == 'development')

function selectHtmlEl(elId, timeout = 1200) {
  setTimeout(() => {
    let el = document.getElementById(elId)
    if (el) el.click()
  }, timeout)
};

export default {
  mixins: [
    commons, 
    time_limit, 
    monitor, 
    monitor_item_properties,
    filtered_list_routing
  ],

  components: {
    DataItemRow,
    DBeing,
    LoadingModal,
    FlexForm,
    ProcessControlPanel,
    FilterContainer,
    BeingAvatar
  },

  computed: {
    ...mapGetters('app/layout', ['getRouteData']),
    binding: function () {
      const binding = {}

      if (this.$vuetify.breakpoint.mdAndDown) 
        binding.column = true
      else 
        binding.row = true

      return binding
    },
    postsInfo: function () {
      // return this.$store.getters['orgStructure/postInfoList']()
      return []
    },
    linkOrValue() {
      return this.link;
    }
  },

  data () {

    return {
      link: '',
      currentItem: {},
      loadingItemDataId: null,

      menuProcessInputData: false,

      isInputDataVisible: true,
      isOutputDataVisible: false,
      isInstructionVisible: false,
      isStarterInfoVisible: false,

      isLoadingModalVisible: false,
      isFiltersVisible: true,

      dataLoadingError: false,
      filterLoadingError: false,

      processFormData: [],

      headers: [
        { text: 'Метка', align: 'left', sortable: true, value: 'tag' },
        { text: 'Заголовок', align: 'left', sortable: true, value: 'title' },
        { text: 'Статус', align: 'center', sortable: true, value: 'status' },
        { text: 'Дата запуска', align: 'left', sortable: true, value: 'started' },
        { text: 'Срок выполнения', align: 'left', sortable: false, value: 'time_limit' },
      ],

      portDataHeaders: [
        { text: 'Заголовок', align: 'left', sortable: false, value: 'labelPD' },
        { text: 'Значение', align: 'left', sortable: false, value: 'valuePD' }
      ],

      // Form fields validation rules
      rules: {
        required: (value) => !!value || 'Обязательно для заполнения.',
        email: (value) => {
          const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Неверный e-mail.'
        }
      },
      selectedId: '',
        oldItems: [],
    }
  },

  mounted() {

    if (this.$route && this.$route.query && this.$route.query.selectedId) {
        this.selectedId = this.$route.query.selectedId
    }
  },
    created() {

        // this.$bus.$on('process.start', () => {
        //     this.getListData()
        //     const audio = new Audio('/static/sounds/notification-sound.mp3');
        //     audio.play()
        // }),
        // this.$bus.$on('process.finish', () => {
        //     this.getListData()
        // })
        // this.$bus.$on('process.execute', () => {
        //     this.getListData()
        // })
        // this.$bus.$on('process.hold', () => {
        //     this.getListData()
        // })
        // this.$bus.$on('process.resume', () => {
        //     this.getListData()
        // })
        // this.$bus.$on('process.cancel', () => {
        //     this.getListData()
        // })
        // this.$bus.$on('contractor.assign', () => {
        //     this.getListData()
        // })
        // this.$bus.$on('contractor.dismiss', () => {
        //     this.getListData()
        // })
    },
    destroyed() {
        // this.$bus.$off('process.start')
    },
  methods: {

    selectItem: function ( currentItem ) {

      if ( this.currentItem.id && currentItem.id && this.currentItem.id === currentItem.id ) {
        // Diselect item.
        this.currentItem = ''
      } else {
        this.currentItem = currentItem

        // this.isInputDataVisible = false
        this.isOutputDataVisible = false
        this.isInstructionVisible = false

        // Check selected item status for if upload its input & output data
        // if ( ['running', 'finished', 'hold'].includes( this.currentItem.status ) ) {
          // Item data can be found.
          // Does its exists?
          if ( typeof this.currentItem.data === 'undefined' ) {
            // Need to check for data exists
            this.uploadItemData( this.currentItem )
            this.uploadItemPorts( this.currentItem )
          }
        // }
      }
    },
    updateItemById: function ( item ) {

      if (item && item.id) {

        let index = this.items.findIndex(element => {
          return element.id === item.id
        })

        if (index >= 0) {
          let _item = Object.assign({}, this.items[index], item)
          this.items.splice(index, 1, _item)
        }
      } else {
        console.error("updateItemById: no item or item.id found.");
      }
    },

    getFiltersData: function () {

      this.loadingFilters = true
      this.filterLoadingError = false
      this.filters = []
      let apiPath = apiRoutes.filter.index
      http.get( apiPath ).then(response => {
        if (response.status == 200 && response.data) {
          let filters = []

          // NOTE: take 'status' filter only!
          response.data.forEach(filter => {
            if (filter.code === 'status') {
              filters.push( filter )
            }
          })

          // After loading filters data set selected values.
          this.applyInputFilters( filters )
          this.filters = filters
        } else {
          this.$dmsErrorNoty('Произошла ошибка при загрузке фильтров')
          this.filterLoadingError = true
        }
      }).catch(error => {
        console.warn(error)
        this.$dmsErrorNoty('Произошла ошибка при загрузке фильтров')
        this.filterLoadingError = true
      }).finally(() => {
        this.loadingFilters = false
      })
    },

      getProcesses: function (list) {

        if (this.items.length == 0) {
            return list
        }

        list.forEach((item) => {

            item.isNew = true

            this.items.forEach((el) => {
                if (item.id == el.id) {
                    item.isNew = false
                }
            })
        })

          // console.log(list)

        return list
      },

    getListData: function () {

      this.loading = true
      this.dataLoadingError = false
        // закомментировано, чтобы список процессов перед запросом не очищался
      // this.items = []
      this.totalItems = 0

      let params = {
        page_num: this.pagination.page,
        page_size: this.pagination.rowsPerPage,
        sort_by: this.pagination.sortBy,
        descending: this.pagination.descending,
        filters: {}
      }

      // If there are some active (selected) filters:
      for (let filter in this.inputFilters) {

        if( this.inputFilters.hasOwnProperty( filter ) ) {

          if (Array.isArray(this.inputFilters[filter]) && this.inputFilters[filter].length) {
            params.filters[filter] = []

            this.inputFilters[filter].forEach( element => {
              params.filters[filter].push( element )
            } )
          }
        }
      }

      let apiPath = apiRoutes.monitor.index

      http.get( apiPath + '?' + this.serializeObject( params ) ).then(response => {

        if (response.status == 200 && response.data && Array.isArray(response.data.list)) {

          this.items = this.getProcesses(response.data.list)
          this.totalItems = response.data.total_count

            setTimeout(() => {
                this.items.forEach((item) => {
                    item.isNew = false
                })
            }, 3000)

          if (this.selectedId) {
            selectHtmlEl('testTarget-' + this.selectedId)
            this.$dmsSuccessNoty('Указан процесс для выбора')
          }

        } else {
          this.dataLoadingError = true
          this.$dmsErrorNoty('Произошла ошибка при загрузке данных')
        }
      }).catch(error => {
        console.warn(error)
        this.dataLoadingError = true
        this.$dmsErrorNoty('Произошла ошибка при загрузке данных')
      }).finally(() => {
        // Clear loading indicator
        this.loading = false
      })

    },


    /**
     * Upload process base data from server.
     */
    uploadItem: function ( item ) {

      if (item && item.id) {

        let apiPath = apiRoutes.monitor.show.replace( '{process_id}', item.id )

        http.get( apiPath ).then(response => {

          if (response.status == 200 && response.data && response.data.item) {

            // And upload all process data (input, outputs, ports)
            this.uploadItemData( response.data.item )
            this.uploadItemPorts( response.data.item )

            // Replace existing list item with a new value.
            this.updateItemById( response.data.item )
          }
        }).catch(error => {
          console.warn(error)
        })
      } else {
        console.error("uploadItem: no item or item.id found.");
      }
    },

    /**
     * Upload process input & output data from server if it does not exist yet.
     */
    uploadItemData: function ( item ) {

      if (item && item.id) {

        if (typeof item.data === 'undefined') {

          this.loadingItemDataId = item.id

          let apiPath = apiRoutes.monitor.data.replace( '{process_id}', item.id )

          http.get( apiPath ).then(response => {
            if (response.status == 200 && response.data) {
              item.data = response.data
              this.updateItemById( item )
            }
          }).catch(error => {
            console.warn(error)
          }).finally(() => {
            this.loadingItemDataId = null
          })
        } else {
          console.log("uploadItemData: item.data already exists.");
        }
      } else {
        console.error("uploadItemData: no item or item.id found.");
      }
    },

    /**
     * Upload process ports data from server if it does not exist yet.
     */
    uploadItemPorts: function ( item ) {

      if (item && item.id) {

        if (typeof item.ports === 'undefined') {

          let apiPath = apiRoutes.monitor.ports.replace( '{process_id}', item.id )

          http.get( apiPath ).then(response => {
            if (response.status == 200 && response.data && response.data.data) {
              item.ports = response.data.data
              this.updateItemById( item )
            }
          }).catch(error => {
            console.warn(error)
          })
        } else {
          console.log("uploadItemPorts, items.ports already exists.");
        }
      } else {
        console.error("uploadItemPorts: no item or item.id found.");
      }
    },

    /**
     * Start process execution
     *
     */
    startExecution: function () {

      // Show confirm dialog
      this.$store.dispatch('confirmer/ask', {
        body: 'Приступить к выполнению данного задания?',
        type: 'ask',
        // color: 'success'
      }).then(confirmed => {

        if (confirmed) {
          // Show loading indicator
          this.isLoadingModalVisible = true

          let apiPath = apiRoutes.monitor.beginProcess.replace( '{process_id}', this.currentItem.id )

          // Send server request to start process execution.
          http.patch( apiPath ).then(response => {

            if ( [200, 201].includes(response.status) ) {

              // 3.2. Show info message
              this.$dmsInfoNoty('Процесс принят к работе.')

              // 3.3. Update process data: status, etc.
              // console.log("startExecution, this.currentItem:");
              // console.log(this.currentItem)
              this.uploadItem( this.currentItem )

              // 3.4. Get process input data list
              // this.uploadItemData( this.currentItem )

              // 3.5. Get process output ports list
              // this.uploadItemPorts( this.currentItem )

            } else {

              // 3.2. Show info message
              this.$dmsErrorNoty('Возникла ошибка при запуске задания.')
            }
          }).catch(error => {
            console.warn(error)

            // 3.2. Show info message
            this.$dmsErrorNoty('Возникла ошибка при запуске задания.')
          }).finally(() => {
            // 3.1. Hide loading indicator
            this.isLoadingModalVisible = false
          })
        }
      })
    },

    /**
     *  Show flex form according output port.
     *
     */
    showFlexForm: function ( portId ) {

      this.$refs.processDataForm.show()





      // // Show loading indicator
      // this.isLoadingModalVisible = true
      //
      // // Send request to get form data if it exists.
      // let apiPath = apiRoutes.monitor.portForm
      // apiPath = apiPath.replace( '{process_id}', this.currentItem.id )
      // apiPath = apiPath.replace( '{port_id}', portId )
      //
      // http.get( apiPath ).then(response => {
      //
      //   if ( [ 200, 201 ].includes(response.status) ) {
      //
      //     // Check for form data exists.
      //     if ( response.data && response.data.data && (response.data.data.length > 0) ) {
      //
      //       // // Show flex form
      //       // let formProps = {
      //       //   formData: response.data.data
      //       // }
      //
      //       // // Вывод диалогового окна с формой данных для завершения процесса.
      //       // this.$store.dispatch('confirmer/ask', {
      //       //
      //       //   title: this.currentItem.extended_finish
      //       //     ? 'Передача управления'
      //       //     : 'Завершение выполнения',
      //       //   body: '<div class="subheading">Заполните выходные данные</div>',
      //       //   component: Form, // FlexForm,
      //       //   props: formProps,
      //       //   confirmText: this.currentItem.extended_finish
      //       //     ? 'Передать управление'
      //       //     : 'Завершить выполнение',
      //       //   cancelText: 'Отменить',
      //       //   width: 640
      //       // }).then(confirmed => {
      //       //
      //       //   if (confirmed) {
      //       //     // console.log("formProps.formData:", formProps.formData)
      //       //     this.sendFlexFormData( portId, formProps.formData )
      //       //   }
      //       // })
      //
      //
      //
      //       // this.$dmsShowDialog( {
      //       //
      //       //   component: Form,
      //       //
      //       //   props: {
      //       //
      //       //     caption: 'Завершение процесса',
      //       //     formData: formProps.formData
      //       //   },
      //       //
      //       //   listeners: {
      //       //     confirm: ( data ) => {
      //       //
      //       //       console.log( `Процесс завершен >>> `, data )
      //       //       this.sendFlexFormData( portId, data )
      //       //     }
      //       //   },
      //       //
      //       //   dialogProps: {
      //       //     maxWidth: 500,
      //       //     scrollable: true
      //       //   }
      //       // } )
      //
      //
      //
      //       // this.processFormData = response.data.data
      //       //
      //       // this.$nextTick( () => {
      //       //   this.$refs.processDataForm.show()
      //       // } )
      //
      //
      //
      //     } else {
      //
      //       // Finish process without form.
      //       // Ask for it.
      //       this.$store.dispatch('confirmer/ask', {
      //
      //         body: (this.currentItem.extended_finish
      //           ? 'Передать управление через выбранный порт?'
      //           : 'Завершить выполнение через выбранный порт?')
      //           + '<br/>Заполнение формы с выходными данными не требуется.',
      //         type: 'ask',
      //       }).then(confirmed => {
      //
      //         if (confirmed) {
      //           this.sendFlexFormData( portId )
      //         }
      //       })
      //     }
      //   } else {
      //     // Show info message
      //     this.$dmsErrorNoty('Возникла ошибка при выполнении операции.')
      //   }
      // }).catch(error => {
      //
      //   console.warn(error)
      //
      //   // Show info message
      //   this.$dmsErrorNoty('Возникла ошибка при выполнении операции.')
      // }).finally(() => {
      //   // Hide loading indicator
      //   this.isLoadingModalVisible = false
      // })
    },

    /**
     *
     *
     */
    sendFlexFormData: function ( portId, portData = null ) {

      // Show loading indicator
      this.isLoadingModalVisible = true

      // TODO: Validate Flex form data if it needs
      if ( portData && portData.length ) {}

      let apiPath = this.currentItem.extended_finish
        ? apiRoutes.monitor.pushPort
        : apiRoutes.monitor.finishProcess

      apiPath = apiPath.replace( '{process_id}', this.currentItem.id )
      apiPath = apiPath.replace( '{port_id}', portId )

      let _promise = this.currentItem.extended_finish
        ? http.put( apiPath, { data: portData } )
        : http.patch( apiPath, { data: portData, port_id: portId } )

      _promise.then(response => {

        if ( [200, 201].includes(response.status) ) {

          // Show info message
          this.$dmsSuccessNoty('Операция выполнена успешно.')

          // Update existing list item.
          this.uploadItem( this.currentItem )
        } else {
          // Show info message
          this.$dmsErrorNoty('Возникла ошибка при выпонении операции.')
        }
      }).catch(error => {
        console.warn(error)

        // Show info message
        this.$dmsErrorNoty('Возникла ошибка при выпонении операции.')
      }).finally(() => {
        // Hide loading indicator
        this.isLoadingModalVisible = false
      })
    },

    /**
     * Finish process execution
     */
    finishExecution: function ( portId ) {

      // Show confirm dialog
      this.$store.dispatch('confirmer/ask', {
        body: 'Завершить выполнение данного задания?',
        type: 'ask'
      }).then(confirmed => {

        if (confirmed) {
          // Show loading indicator
          this.isLoadingModalVisible = true

          // Request to finish process
          let apiPath = apiRoutes.monitor.finishProcess
          apiPath = apiPath.replace( '{process_id}', this.currentItem.id )

          http.patch( apiPath ).then(response => {
            if ( [200, 201].includes(response.status) ) {
              // Show info message
              this.$dmsSuccessNoty('Задание успешно завершено.')
            } else {
              // Show info message
              this.$dmsErrorNoty('Возникла ошибка при завершении задания.')
            }

            // Update process data: status, etc.
            this.uploadItem( this.currentItem )
          }).catch(error => {
            console.warn(error)

            this.$dmsErrorNoty('Возникла ошибка при завершении задания.')
          }).finally(() => {
            // Hide loading indicator
            this.isLoadingModalVisible = false
          })
        }
      })
    },

    
    //
    // Progress indicator functions.
    //
    
    getProgressValueClass: function ( item ) {

      let classStr = ''

      switch (item.status) {
        case 'running':
        case 'pool':
        case 'pending':
          classStr = "light-green lighten-2"
          if (item.time_limit && ((item.started_at + item.time_limit) * 1000 < Date.now())) {
            // Prosr.
            classStr = "deep-orange lighten-2"
          }
          break;
        default:
          classStr = "grey"
      }

      return classStr
    },

    getProgressValueStyle: function ( item ) {

      let styleStr = ''
      let procDone = 0

      if (item.time_limit && ['running', 'pool', 'pending'].includes(item.status)) {
        // 'time limit' - сколько есть времени на исполнения (в секундах)
        // ('now' - 'started_at') - сколько времени уже прошло
        // Время вычисляется в секундах
        procDone = (Date.now()/1000 - item.started_at) / item.time_limit * 100

        if (procDone >= 100) {
          procDone = 100
          // clearInterval(this.timerId);
        }
      }
      if (procDone) {
        // this.progressValue = procDone
        styleStr = `width: ${procDone}%;`
      }

      return styleStr
    },

    getProgressFloorClass: function ( item ) {

      let classStr = ''

      switch (item.status) {
        case 'running':
        case 'pool':
        case 'pending':
          classStr = "pink accent-1"
          break;
        default:
          classStr = "primary"
      }

      return classStr
    },

    getProgressFloorStyle: function ( item ) {

      let styleStr = ''

      switch (item.status) {
        case 'running':
        case 'pool':
        case 'pending':
          styleStr = "background-color: ;"
          break;

        default:
          styleStr = "background-color: ;"
      }

      return styleStr
    }
  }
}
</script>

<style lang="scss">
#process-list-table td, #process-list-table th {
  padding: 3px 5px;
  height: auto;
}

.process-step-info {
  min-height: 300px;
}
@keyframes goldenrain {
  0% {background-color: transparent;}
  50% {background-color: #c8e6c9;}
  100% {background-color: transparent;}
}
  .new-item {
    animation: goldenrain .8s ease 4;
  }
</style>



// WEBPACK FOOTER //
// src/apps/bpm/monitor/pages/ExecMonitor.vue